export const useAppStore = defineStore("app", () => {
  const init = async (storesToSkip = ["auth", "app"]) => {
    try {
      useNotificationStore();

      const pinia = getActivePinia();
      const storesToInit = pinia._s;
      const storeInitActions = [];

      for (const [storeKey, store] of storesToInit) {
        if (!storesToSkip.includes(storeKey)) {
          if (store.init && typeof store.init === "function") {
            storeInitActions.push(store.init());
          }
        }
      }

      await Promise.all(storeInitActions);
    } catch (error) {
      console.error(error);
    }
  };

  const isRightDrawerOpen = ref(false);
  const rightDrawerComponentProps = ref({});
  const rightDrawerComponent = shallowRef(null);

  const toggleRightDrawer = (
    isOpen = !isRightDrawerOpen.value,
    component,
    props = {},
  ) => {
    isRightDrawerOpen.value = isOpen;

    rightDrawerComponent.value = component;

    rightDrawerComponentProps.value = props;
  };

  const nestedRightDrawers = shallowRef([
    {
      open: false,
      component: null,
      props: {},
    },
  ]);

  const toggleNestedRightDrawer = ({
    level = 0,
    open,
    component = null,
    props = {},
  } = {}) => {
    open = open ?? !unref(nestedRightDrawers)?.[level]?.open;

    unref(nestedRightDrawers)[level] = { component, open, props };

    nestedRightDrawers.value = [...unref(nestedRightDrawers)];
  };

  const reset = (storesToSkip = ["auth", "app"]) => {
    try {
      const pinia = getActivePinia();
      const storesToReset = pinia._s;

      for (const [storeKey, store] of storesToReset) {
        if (!storesToSkip.includes(storeKey)) {
          if (store.reset && typeof store.reset === "function") {
            store.reset();
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const scrollReset = ref(false);

  const setScrollReset = (value) => {
    scrollReset.value = !!value;
  };

  return {
    isRightDrawerOpen,
    rightDrawerComponent,
    rightDrawerComponentProps,

    nestedRightDrawers,

    init,
    reset,

    toggleRightDrawer,
    toggleNestedRightDrawer,

    scrollReset,
    setScrollReset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
}
